async function sendFormData(formData) {
    try {
        const response = await fetch('/api/verify-turnstile.php', {
            method: 'POST',
            body: formData
        });

        const contentType = response.headers.get('content-type') || '';
        const data = contentType.includes('application/json')
            ? await response.json()
            : { message: await response.text() };

        if (!response.ok) throw data;

        return data;
    } catch (error) {
        console.error('sendFormData ERROR', error);
        return Promise.reject(error);
    }
}

export async function sendCareersFormData(formData) {
    return sendFormData(formData);
}

export async function sendSupportFormData(formData) {
    return sendFormData(formData);
}

export async function sendPartnershipFormData(formData) {
    return sendFormData(formData);
}

export async function sendPublishingFormData(formData) {
    return sendFormData(formData);
}